import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ImpersonationBanner } from './ImpersonationBanner';
import { AssistantDock } from '../assistant/AssistantDock';
/** Scroll back to the top of the page on every route change. */
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);
    return null;
}
export function AdminLayout() {
    return (_jsxs("div", { className: "flex min-h-screen bg-[#f8f9fb]", children: [_jsx(ScrollToTop, {}), _jsx(Sidebar, {}), _jsxs("div", { className: "flex-1 flex flex-col min-w-0", children: [_jsx(ImpersonationBanner, {}), _jsx(Header, {}), _jsx("main", { className: "flex-1 p-6 max-w-[1400px] print:p-0 print:max-w-none", children: _jsx(Outlet, {}) })] }), _jsx(AssistantDock, {})] }));
}
